import { AxiosInstance } from 'axios';
import { CommodityServicesEndpoint } from './CommodityServices.types';

export class CommodityServices implements CommodityServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  decodeVins(vins: string[]) {
    return this.instance.post('/commodity/decodevins', { vins });
  }
}
